import OrganizationContent from './OrganizationContent';

export default OrganizationContent;
